<template>
  <div class="card">
    <Toast />
    <div class="title">Klaim Hadiah</div>

    <div class="p-grid p-fluid p-mb-2">
      <div class="p-col-12 p-md-4">
        <SelectButton
          v-model="mode"
          :options="modeOptions"
          optionLabel="label"
          optionValue="value"
          @change="onModeChange"
        />
      </div>
    </div>

    <div class="p-grid p-fluid p-formgroup-inline">
      <div class="p-field p-col-4">
        <InputText
          v-if="mode === 'invoice'"
          placeholder="Nomor Invoice"
          ref="invoice_number"
          v-model="invoice_number"
          v-shortkey.push="['enter']"
        />
        <InputText
          v-else
          placeholder="Nomor HP"
          ref="phone_number"
          v-model="phone_number"
          v-shortkey.push="['enter']"
        />
        <div>
          <small class="p-error" v-if="isError.invoice_number">{{
            error_msg.invoice_number
          }}</small>
        </div>
      </div>
      <div class="p-col-2 text-center">
        <Button
          @click="mode === 'invoice' ? getAmountTransaction() : lookupByPhone()"
        >
          <span v-if="loading">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
          <span class="p-button-label" v-else>
            {{ mode === 'invoice' ? 'Cek Invoice' : 'Cek HP' }}
          </span>
        </Button>
      </div>
    </div>

    <div
      v-if="mode === 'invoice' && detail_invoice != null && amount > 0"
      class="gift-header-section"
    >
      <div class="p-grid p-fluid p-mb-2 p-col-12" style="margin: auto">
        <div class="p-col-3">
          <InputText v-model="filter.kode" placeholder="Kode Barang" />
        </div>
        <div class="p-col-2">
          <Button
            label="Cari"
            class="p-button-info"
            @click="getEligableGift()"
          />
        </div>
        <div class="p-col" style="margin-left: 8rem">
          <p style="font-size: 16px; line-height: 0.1rem">
            Nomor invoice : <b>{{ detail_invoice.invoice }}</b>
          </p>
          <p style="font-size: 14px">
            Total belanja : <b>{{ detail_invoice.billed_amount | currency }}</b>
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="mode === 'phone' && phone_lookup != null"
      class="gift-header-section"
    >
      <div class="p-grid p-fluid p-mb-2 p-col-12" style="margin: auto">
        <div class="p-col" style="margin-left: 1rem">
          <p style="font-size: 16px; line-height: 0.4rem">
            Nomor HP : <b>{{ phone_lookup.phone }}</b>
          </p>
          <p style="font-size: 16px; line-height: 0.4rem">
            Nama : <b>{{ phone_lookup.customer_name || '-' }}</b>
          </p>
          <p style="font-size: 14px">
            Point tersedia :
            <b>{{ phone_lookup.points_available | number }}</b>
          </p>
        </div>
      </div>
    </div>

    <div class="p-grid p-fluid p-col">
      <table class="table table-responsive">
        <thead class="thead-light">
          <tr v-if="detail_invoice != null || phone_lookup != null">
            <th class="text-center">No</th>
            <th class="text-center">Jumlah</th>
            <th class="text-center">Kode barang</th>
            <th class="text-center">Nama barang</th>
            <th class="text-center">Stok</th>
            <th class="text-center">Kode kategori</th>
            <th class="text-center">
              {{ mode === 'phone' ? 'Point / Hadiah' : 'Range Harga' }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(an_item, k) in dataItem.eligable_gift" :key="k">
            <td class="text-center">{{ k + 1 }}</td>
            <td class="text-center">
              <div>
                <InputText
                  v-model="an_item.jml"
                  type="number"
                  style="width: 50pt"
                  :max="an_item.stock"
                  :min="0"
                  @keyup.prevent="qtyChanges(k)"
                  @blur="validateQuantity(k)"
                  :class="{
                    'p-invalid':
                      isError.eligable_gift[k] && isError.eligable_gift[k].stock
                  }"
                />
              </div>
              <small
                class="p-error"
                v-if="
                  isError.eligable_gift[k] && isError.eligable_gift[k].stock
                "
              >
                {{
                  error_msg.eligable_gift[k] && error_msg.eligable_gift[k].stock
                }}
              </small>
            </td>
            <td class="text-center">{{ an_item.code }}</td>
            <td class="text-center">{{ an_item.name }}</td>
            <td class="text-center">{{ an_item.stock }}</td>
            <td class="text-center">{{ an_item.categoryID }}</td>
            <td class="text-center">
              <span v-if="mode === 'phone'">{{
                an_item.point_cost | number
              }}</span>
              <span v-else>{{ an_item.minPrice | currency }}</span>
            </td>
          </tr>
          <tr v-if="dataItem.eligable_gift.length != 0">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <b>
                {{ mode === 'phone' ? 'Total Point' : 'Total Hadiah' }}<br />
                Total Qty
              </b>
            </td>
            <td>
              <b>
                <span v-if="mode === 'phone'">{{ allPoints | number }}</span>
                <span v-else>{{ allPrice | currency }}</span>
                <br />{{ qty | number }}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="p-grid p-fluid p-justify-center"
      v-if="dataItem.eligable_gift.length != 0"
    >
      <div class="p-col-12 p-md-6 p-lg-3">
        <Button
          :disabled="generateButton"
          @click="klaimGift()"
          label="Klaim"
          style="position: relative"
        >
          <span
            v-if="loading"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
            loading
          </span>
        </Button>
      </div>
    </div>

    <!-- Receipt Preview Dialog -->
    <ReceiptPreviewDialog
      :visible.sync="dialog.receiptPreview"
      :invoice-id="giftReceiptInvoiceId"
      :receipt-data-prop="giftReceiptData"
      @close="handleGiftReceiptDialogClose"
    />
  </div>
</template>

<script>
import ReceiptPreviewDialog from '@/components/pos/ReceiptPreviewDialog.vue'
import receiptService from '@/services/receiptService'

export default {
  components: {
    ReceiptPreviewDialog
  },
  data() {
    return {
      mode: 'invoice',
      modeOptions: [
        { label: 'Nomor Invoice', value: 'invoice' },
        { label: 'Nomor HP', value: 'phone' }
      ],
      allPrice: 0,
      allPoints: 0,
      amount: null,
      detail_invoice: null,
      invoice_number: null,
      phone_number: null,
      phone_lookup: null,
      generateButton: true,
      qty: 0,
      dataItem: {
        eligable_gift: [],
        cust_id: null
      },

      transaction: {
        cust_id: null,
        invoice: null,
        phone: null,
        items: []
      },

      isError: {
        invoice_number: null,
        stock: false,
        eligable_gift: []
      },
      error_msg: {
        invoice_number: null,
        eligable_gift: []
      },

      filter: {
        kode: ''
      },
      loading: false,
      dialog: {
        receiptPreview: false
      },
      giftReceiptData: null,
      giftReceiptInvoiceId: null,
      // Held across retries within the same Klaim click so the backend can
      // recognise a network-glitch retry and replay the previous success
      // instead of returning "invoice sudah kepakai". Reset only after a
      // successful commit or when the whole claim is cleared.
      claimIdempotencyKey: null
    }
  },
  mounted() {
    setTimeout(this.setFocus, 1000)
  },
  methods: {
    setFocus() {
      const ref =
        this.mode === 'phone'
          ? this.$refs.phone_number
          : this.$refs.invoice_number
      if (ref && ref.$el) {
        ref.$el.focus()
      }
    },

    onModeChange() {
      // Switching mode is always a fresh claim scope — every piece of state
      // from the previous mode must go, including the idempotency key.
      this.clearGiftClaim()
      this.$nextTick(this.setFocus)
    },

    // Phone flow: one round-trip returns the customer, their live Mode Lovers
    // point balance, and the gift items available at this outlet with cost.
    // The cashier picks items visually before klaim; the POST re-validates.
    lookupByPhone() {
      this.claimIdempotencyKey = null
      if (!this.phone_number) {
        this.isError.invoice_number = true
        this.error_msg.invoice_number = 'Nomor HP tidak boleh kosong'
        return
      }
      this.loading = true
      this.$http
        .get(
          `${
            process.env.VUE_APP_API_URL
          }/transactions/gift/lookup?phone=${encodeURIComponent(
            this.phone_number
          )}`
        )
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            const d = response.data.data
            this.phone_lookup = {
              cust_id: d.cust_id,
              customer_name: d.customer_name,
              phone: d.phone,
              points_available: d.points_available
            }
            this.dataItem.cust_id = d.cust_id
            this.isError.invoice_number = false
            this.dataItem.eligable_gift = (d.gift_items || []).map(it => ({
              id: it.id,
              code: it.code,
              name: it.name,
              stock: it.stock,
              categoryID: it.cat_id,
              point_cost: it.point_cost,
              // minPrice kept so the invoice-flow code paths keep working
              // if the same array is reused; unused in phone rendering.
              minPrice: 0,
              jml: null,
              total_price: 0
            }))
            this.isError.eligable_gift = this.dataItem.eligable_gift.map(
              () => ({
                stock: false
              })
            )
            this.error_msg.eligable_gift = this.dataItem.eligable_gift.map(
              () => ({ stock: '' })
            )
            if (this.dataItem.eligable_gift.length === 0) {
              this.$toast.add({
                severity: 'info',
                summary: 'Tidak ada hadiah tersedia',
                detail: 'Stok hadiah di outlet ini kosong',
                life: 3000
              })
            }
          }
        })
        .catch(error => {
          this.loading = false
          this.phone_lookup = null
          this.dataItem.eligable_gift = []
          const status =
            error.response && error.response.status ? error.response.status : 0
          const msg =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : ''
          let detail = 'Coba nomor HP lain'
          if (status === 404 || msg.includes('customer_not_found')) {
            detail = 'Customer dengan nomor HP tersebut tidak terdaftar'
          }
          this.$toast.add({
            severity: 'error',
            summary: 'Lookup gagal',
            detail,
            life: 3000
          })
        })
    },

    getEligableGift() {
      let code = ''
      if (this.filter.kode) {
        code = this.filter.kode
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/items/gift?invoice=${this.invoice_number}&total=${this.detail_invoice.billed_amount}&code=${code}`
        )
        .then(response => {
          if (response.status === 200) {
            this.dataItem.eligable_gift = response.data.data.giftItem
            // Initialize error arrays and add total_price in every array
            this.isError.eligable_gift = []
            this.error_msg.eligable_gift = []
            this.dataItem.eligable_gift.forEach((item, index) => {
              this.$set(this.dataItem.eligable_gift[index], 'total_price', 0)
              this.$set(this.dataItem.eligable_gift[index], 'jml', null)
              // Initialize error objects for each item
              this.isError.eligable_gift.push({ stock: false })
              this.error_msg.eligable_gift.push({ stock: '' })
            })
          } else {
            console.log('hadiah kosong')
          }
        })
    },
    getAmountTransaction() {
      // A fresh invoice lookup starts a new claim scope, so any key held
      // from a prior invoice must not carry over — otherwise the backend
      // (opaque-replay) could return the previous invoice's response for
      // this one's payload.
      this.claimIdempotencyKey = null
      if (this.invoice_number != null) {
        this.loading = true
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/invoice?invoice_number=${this.invoice_number}`
          )
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.detail_invoice = response.data.data
              // Use billed_amount for total purchase amount (Total Belanja)
              this.amount = parseFloat(response.data.data.billed_amount) || 0
              this.dataItem.cust_id = response.data.data.cust_id
              this.isError.invoice_number = false
              this.dataItem.eligable_gift = []
              if (this.amount > 0) {
                this.getEligableGift()
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Not Eligible',
                  detail: 'Please try another invoice',
                  life: 3000
                })
              }
            } else {
              this.loading = false
              if (response.data.message == 'error.insufficient_point') {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Not Eligible',
                  detail: 'The customer points is not sufficient',
                  life: 3000
                })
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Not Eligible',
                  detail: 'Try different invoice',
                  life: 3000
                })
              }
            }
          })
          .catch(error => {
            this.loading = false
            this.detail_invoice = null
            this.amount = null
            this.dataItem.cust_id = null
            this.dataItem.eligable_gift = []
            console.log(error)
            this.$toast.add({
              severity: 'error',
              summary: 'Invoice not found',
              detail: 'Please try another invoice',
              life: 3000
            })
          })
      } else {
        this.loading = false
        this.detail_invoice = null
        this.amount = null
        this.dataItem.cust_id = null
        this.isError.invoice_number = true
        this.error_msg.invoice_number = 'Nomor Invoice tidak boleh kosong'
      }
    },

    qtyChanges(index) {
      let qty = 0
      if (this.dataItem.eligable_gift[index].jml) {
        qty = parseInt(this.dataItem.eligable_gift[index].jml)
      }

      if (index > -1) {
        this.dataItem.eligable_gift[index].jml = qty
      }

      if (
        this.dataItem.eligable_gift[index].jml <=
        this.dataItem.eligable_gift[index].stock
      ) {
        const unitCost =
          this.mode === 'phone'
            ? parseInt(this.dataItem.eligable_gift[index].point_cost) || 0
            : parseFloat(this.dataItem.eligable_gift[index].minPrice) || 0
        this.dataItem.eligable_gift[index].total_price = qty * unitCost
        this.calculateTotal()
      }
    },

    calculateTotal() {
      var subtotal = 0,
        qty = 0
      for (var i = 0; i < this.dataItem.eligable_gift.length; i++) {
        var lineTotal = parseFloat(this.dataItem.eligable_gift[i].total_price)
        var qtyTotal = parseFloat(this.dataItem.eligable_gift[i].jml)
        if (!isNaN(lineTotal) && !isNaN(qtyTotal)) {
          subtotal += lineTotal
          qty += qtyTotal
        }
      }
      if (subtotal != undefined && subtotal != undefined) {
        this.dataItem.eligable_gift.total_price = subtotal.toFixed(2)
        this.dataItem.eligable_gift.jml = qty
      }
      this.qty = qty

      if (this.mode === 'phone') {
        this.allPoints = subtotal
        this.allPrice = 0
        const available =
          (this.phone_lookup && this.phone_lookup.points_available) || 0
        if (this.allPoints === 0) {
          this.generateButton = true
        } else if (this.allPoints > 0 && this.allPoints <= available) {
          this.generateButton = false
        } else {
          this.generateButton = true
          this.$toast.add({
            severity: 'error',
            summary: 'Point kurang',
            detail: 'Total point hadiah melebihi point customer',
            life: 3000
          })
        }
      } else {
        this.allPrice = subtotal
        this.allPoints = 0
        if (this.allPrice === 0) {
          this.generateButton = true
        } else if (this.allPrice > 0 && this.allPrice <= this.amount) {
          this.generateButton = false
        } else {
          this.generateButton = true
          this.$toast.add({
            severity: 'error',
            summary: 'Kelebihan',
            detail: 'Hadiah melebihi total transaksi',
            life: 3000
          })
        }
      }
    },

    klaimGift() {
      this.loading = true
      if (
        this.dataItem.eligable_gift.length === 0 ||
        this.dataItem.eligable_gift.length === null
      ) {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Cart gift is empty',
          detail: 'Please, select at least one item',
          life: 3000
        })
        return
      }

      // Reset transaction items before building new claim
      this.transaction.items = []

      // penangkapan parameter datanya
      this.transaction.cust_id = this.dataItem.cust_id
      if (this.mode === 'phone') {
        this.transaction.invoice = ''
        this.transaction.phone = this.phone_number
      } else {
        this.transaction.invoice = this.invoice_number
        this.transaction.phone = ''
      }
      for (var i = 0; i < this.dataItem.eligable_gift.length; i++) {
        if (
          this.dataItem.eligable_gift[i].jml != null &&
          this.dataItem.eligable_gift[i].jml > 0
        ) {
          this.transaction.items.push({
            id: this.dataItem.eligable_gift[i].id,
            qty: this.dataItem.eligable_gift[i].jml
          })
        }
      }

      // Validate that at least one item was added
      if (this.transaction.items.length === 0) {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Cart gift is empty',
          detail: 'Please, select at least one item',
          life: 3000
        })
        return
      }

      // Keep key across retries so the backend can replay a dropped success.
      if (!this.claimIdempotencyKey) {
        this.claimIdempotencyKey = this.generateIdempotencyKey()
      }

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/transactions/gift`,
          this.transaction,
          {
            headers: { 'Idempotency-Key': this.claimIdempotencyKey }
          }
        )
        .then(async response => {
          this.loading = false
          if (response.status === 200) {
            // Retire the key: the claim is committed, next click needs a fresh window.
            this.claimIdempotencyKey = null
            // Show success message
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: 'Hadiah berhasil diklaim',
              life: 3000
            })

            // Extract invoice ID from response
            // Use explicit null checks instead of optional chaining for Vue 2 compatibility
            let invoiceId = null
            if (
              response.data &&
              response.data.data &&
              response.data.data.invoice_id
            ) {
              invoiceId = response.data.data.invoice_id
            }

            if (invoiceId) {
              // Fetch receipt data
              await this.fetchGiftReceipt(invoiceId)

              // Show receipt preview dialog
              this.$nextTick(() => {
                this.dialog.receiptPreview = true
              })
            } else {
              // Fallback: if no invoice ID, just show success and clear
              this.$toast.add({
                severity: 'info',
                summary: 'Info',
                detail: 'Struk tidak tersedia',
                life: 3000
              })
              this.clearGiftClaim()
              setTimeout(() => {
                this.$router.push({ name: 'pos' })
              }, 500)
            }
          } else {
            this.isError.invoice_number = false
            this.$toast.add({
              severity: 'error',
              summary: 'Claim Gift Error',
              detail: 'Sorry, Claim gift failed',
              life: 3000
            })
          }
        })
        .catch(error => {
          this.loading = false
          // Preserve the key only for genuine network drops (no response received).
          // A concrete HTTP response — success or error — means the backend made
          // a decision, so the next attempt must not replay this one's outcome.
          if (error.response) {
            this.claimIdempotencyKey = null
          }
          console.error('Error claiming gift:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Claim Gift Error',
            detail:
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : 'Sorry, Claim gift failed. Please try again.',
            life: 3000
          })
        })
    },

    async fetchGiftReceipt(invoiceId) {
      try {
        // Use receipt service to fetch receipt data
        const receiptData = await receiptService.fetchReceipt(
          invoiceId,
          this.$http
        )

        this.giftReceiptData = receiptData
        this.giftReceiptInvoiceId = invoiceId
      } catch (error) {
        console.error('Error fetching gift receipt:', error)
        // Don't throw - allow dialog to open with error state
        // The dialog will handle the error display
        this.giftReceiptData = null
        this.giftReceiptInvoiceId = invoiceId
      }
    },
    handleGiftReceiptDialogClose() {
      // Close dialog
      this.dialog.receiptPreview = false

      // Clear receipt data
      this.giftReceiptData = null
      this.giftReceiptInvoiceId = null

      // Clear form
      this.clearGiftClaim()

      // Navigate to POS after delay
      setTimeout(() => {
        this.$router.push({ name: 'pos' })
      }, 500)
    },
    clearGiftClaim() {
      this.loading = false
      this.amount = null
      this.detail_invoice = null
      this.invoice_number = null
      this.phone_number = null
      this.phone_lookup = null
      this.allPrice = 0
      this.allPoints = 0
      this.qty = 0
      this.generateButton = true
      this.dataItem = {
        eligable_gift: [],
        cust_id: null
      }

      this.transaction = {
        cust_id: null,
        invoice: null,
        phone: null,
        items: []
      }
      this.isError = {
        invoice_number: null,
        stock: false,
        eligable_gift: []
      }
      this.error_msg = {
        invoice_number: null,
        eligable_gift: []
      }
      this.claimIdempotencyKey = null
    },

    // RFC 4122 v4 UUID. Prefers the platform crypto implementation and
    // falls back to Math.random for environments without it. The value is
    // only used as an opaque identifier for the backend replay guard, so
    // the Math.random fallback is acceptable even though it isn't
    // cryptographic-quality.
    generateIdempotencyKey() {
      if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
      ) {
        return crypto.randomUUID()
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
